import React from "react";
import img2 from "../../Assets/Images/investor3.png";
import img3 from "../../Assets/Images/investor1.png";
import img4 from "../../Assets/Images/investor2.png";

const InvestmentCornerPartTwo = () => {
  const handleWhatsApp = () => {
    const phoneNumber = "918908651439";
    const whatsappUrl = `https://wa.me/${phoneNumber}`;
    window.open(whatsappUrl, "_blank");
  };
  return (
    <div className="bg-white my-12 md:my-24 px-4 sm:px-6 lg:px-8">
      <div className="w-full mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="space-y-6">
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold">
              <span className="text-[#FF5A3C]">Investment</span>{" "}
              <span className="text-gray-900">Corner for</span>
              <br />
              <span className="text-gray-900">Investors</span>
            </h2>

            <p className="text-gray-600 text-sm sm:text-base md:text-md leading-relaxed text-justify">
              At Covenants, We Offer Lucrative Real Estate Investment
              Opportunities Designed For Long-Term Growth And Stability. With
              Strategic Locations, High- Quality Developments, And A Commitment
              To Innovation, Our Projects Promise Strong Returns And Enduring
              Value. Partner With Us To Capitalize On A Thriving Market And
              Secure A Future Of Financial Success.
            </p>

            <button onClick={handleWhatsApp} className="bg-[#FF5A3C] hover:bg-orange-600 text-white font-semibold py-3 px-8 rounded-lg transition-colors duration-300">
              Contact Us
            </button>
          </div>

          <div className="grid grid-cols-2 gap-4 h-full">
            <div className="col-span-1 h-full">
              <img
                src={img2}
                alt=""
                className="h-full w-full object-cover rounded-lg"
              />
            </div>

            <div className="flex flex-col gap-4 h-full">
              <img
                src={img3}
                alt=""
                className="h-1/2 w-full object-cover rounded-lg"
              />
              <img
                src={img4}
                alt=""
                className="h-1/2 w-full object-cover rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestmentCornerPartTwo;
